import { useMemo } from 'react';

import { Form, Select } from '@arco-design/web-react';

import { syncSelectOptionMeta, useSyncOptionMetaField } from '../../platform/option-meta';
import type { NetworkSelectFieldProps } from './types';
import { normalizeNetworkSelectValue } from './utils';

/** VPC / 安全组网络资源 Select 表单项 */
export function NetworkSelectField({
  form,
  field,
  label,
  options,
  loading = false,
  disabled = false,
  placeholder,
  required = false,
  requiredMessage,
  normalize = normalizeNetworkSelectValue,
  metaSyncEnabled = true,
  onChange,
  metaKey,
}: NetworkSelectFieldProps) {
  const listItems = useMemo(() => options.map((item) => ({ value: item.value, extra: item.extra })), [options]);
  const fieldValue = Form.useWatch(field, form) as string | undefined;

  useSyncOptionMetaField(form, {
    field,
    listItems,
    enabled: metaSyncEnabled && Boolean(fieldValue && listItems.length),
    lookupKey: metaKey,
  });

  return (
    <Form.Item
      label={label}
      field={field}
      normalize={normalize}
      rules={required ? [{ required: true, message: requiredMessage }] : undefined}
    >
      <Select
        showSearch
        options={options}
        placeholder={placeholder}
        loading={loading}
        disabled={disabled}
        onChange={(value, option) => {
          syncSelectOptionMeta(form, value, option, listItems, metaKey);
          onChange?.(value, option);
        }}
      />
    </Form.Item>
  );
}
